export function fmtDate(value?:string|null):string{
 if(!value)return"—";
 const d=new Date(value);
 return Number.isNaN(d.getTime())?value:d.toLocaleString();
}

export function pretty(value:unknown):string{
 if(value===null||value===undefined)return"—";
 if(typeof value==="string")return value;
 try{return JSON.stringify(value,null,2)}catch{return String(value)}
}

export function humanEnum(value?:string|null):string{
 if(!value)return"—";
 return value
   .replace(/^CredentialDeviceType\./,"")
   .replaceAll("_"," ")
   .toLowerCase()
   .replace(/\b\w/g,m=>m.toUpperCase());
}

export function passkeyType(value?:string|null,backedUp?:boolean):string{
 const raw=(value??"").replace(/^CredentialDeviceType\./,"");
 if(raw==="MULTI_DEVICE"||backedUp)return"Synced passkey";
 if(raw==="SINGLE_DEVICE")return"Device-bound passkey";
 return humanEnum(value)||"Passkey";
}

const EVENT_LABELS:Record<string,string>={
 "security.authority.unlocked":"Security authority unlocked",
 "security.authentication.succeeded":"Authentication succeeded",
 "security.system_access.granted":"System access granted",
 "security.system_secrets.opened":"System secrets opened",
 "security.system_access.revoked":"System access revoked",
 "security.credential.revoked":"Passkey removed",
 "security.credential.enrolled":"Passkey added",
};

export function eventLabel(value:string):string{
 return EVENT_LABELS[value]??value.replaceAll("."," ").replaceAll("_"," ").replace(/\b\w/g,m=>m.toUpperCase());
}

export function resourceLabel(type?:string|null,id?:string|null):string{
 const t=(type??"").replaceAll("_"," ").toLowerCase().replace(/\b\w/g,m=>m.toUpperCase());
 if(!id)return t||"—";
 const safe=id.length>14?`${id.slice(0,8)}…${id.slice(-4)}`:id;
 return `${t||"Resource"} · ${safe}`;
}

export function policyTitle(key:string):string{
 const m:Record<string,string>={
   authority_elevation:"Administrative authority",
   credential_safety:"Passkey safety",
   jit_access:"Temporary privileged access",
   recovery_health:"Recovery protection",
 };
 return m[key]??humanEnum(key);
}

export function policyFacts(key:string,config:unknown):string[]{
 const r=config&&typeof config==="object"&&!Array.isArray(config)?config as Record<string,unknown>:{};
 const facts:string[]=[];
 if(key==="authority_elevation"){
   if(typeof r.ttl_seconds==="number")facts.push(`Authority duration · ${Math.round(r.ttl_seconds/60)} minutes`);
   if(r.fresh_prf_for_key_operations===true)facts.push("Fresh passkey approval required for key operations");
 }
 if(key==="credential_safety"){
   if(r.block_last_unlock_credential===true)facts.push("Last vault-unlocking passkey cannot be removed");
   if(typeof r.warn_below_unlock_credentials==="number")facts.push(`Warn below ${r.warn_below_unlock_credentials} vault-unlocking passkeys`);
 }
 if(key==="jit_access"){
   if(typeof r.max_minutes==="number")facts.push(`Maximum temporary access · ${Math.round(r.max_minutes/60)} hours`);
   if(Array.isArray(r.allowed_levels))facts.push(`Allowed levels · ${r.allowed_levels.join(", ")}`);
   if(r.require_reason===true)facts.push("Reason required for every request");
 }
 if(key==="recovery_health"){
   if(typeof r.minimum_unlock_credentials==="number")facts.push(`Minimum vault-unlocking passkeys · ${r.minimum_unlock_credentials}`);
   if(typeof r.minimum_trust_groups==="number")facts.push(`Minimum independent recovery methods · ${r.minimum_trust_groups}`);
 }
 return facts.length?facts:["Effective policy configuration"];
}

export function settingFacts(key:string,value:unknown):string[]{
 const r=value&&typeof value==="object"&&!Array.isArray(value)?value as Record<string,unknown>:{};
 if(key==="authority_ttl"){
   const facts:string[]=[];
   if(typeof r.seconds==="number")facts.push(`Temporary elevation duration · ${Math.round(r.seconds/60)} minutes`);
   if(r.fresh_prf_for_key_operations===true)facts.push("Fresh passkey approval for key operations · Required");
   return facts.length?facts:["Administrative authority configuration"];
 }
 return [typeof value==="string"?value:pretty(value)];
}
